import React, { useEffect, useState, useMemo } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import '../Produto/index.css';
import logo from '../../imagens/TSTRIPAS.png';

const Cliente = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();  

  const [loadingProdutos, setLoadingProdutos] = useState(true)
  const [produtos, setProdutos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [tipoTripa, setTipoTripa] = useState('');
  const [tipoQualidade, setTipoQualidade] = useState('');
  const [calibre, setCalibre] = useState('');

  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  useEffect(() => {
  const fetchProduto = async () => {
    // Se não estiver logado, evita execução
    if (!userInfo?.url || !userInfo?.alias || !userInfo?.venLogin || !userInfo?.venSenha) {
      return;
    }

    try {
      setLoadingProdutos(true);

      const res = await fetch(`${userInfo.url}/produto/v2`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();

      try {
        const json = JSON.parse(text);
        setProdutos(json);
      } catch (e) {
        console.error("❌ Erro ao converter PRODUTO para JSON:", e);
        throw new Error("Resposta não é JSON");
      }
    } catch (err) {
      console.error('Erro ao buscar PRODUTOS:', err);
    } finally {
      setLoadingProdutos(false);
    }
  };

    fetchProduto();
  }, [userInfo, credentials]);

  const filteredProdutos = produtos.filter((p) => {
    const termo = searchTerm.toLowerCase();
    const matchesSearch = 
      p.descricao?.toLowerCase().includes(termo) ||
      p.tabId?.toLowerCase().includes(termo);

    return matchesSearch;
  });

  const handleSelectProduto = (produto) => {
    setSelectedProduto(produto);
    setSearchTerm(produto.descricao);
    setShowSuggestions(false);
  };

  // 🆕 Memoização de tipos de tripa, qualidade e calibres
  const tiposTripa = useMemo(
    () => [...new Set(
        (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoQualidade || p.qualidade === tipoQualidade) &&
          (!calibre || p.calibre === calibre)
        )
        .map(p => p.tipo)
        .filter(Boolean)
    )],
    [produtos, tipoQualidade, calibre]
  );

  const tiposQualidade = useMemo(
    () => [...new Set(
        (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoTripa || p.tipo === tipoTripa) &&
          (!calibre || p.calibre === calibre)
        )
        .map(p => p.qualidade)
        .filter(Boolean)
    )],
    [produtos, tipoTripa, calibre]
  );

  const calibres = useMemo(
    () => [...new Set(
      (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoTripa || p.tipo === tipoTripa) &&
          (!tipoQualidade || p.qualidade === tipoQualidade)
        )
        .map(p => p.calibre)
        .filter(Boolean)
    )],
    [produtos, tipoTripa, tipoQualidade]
  );

  const handleTipoTripaChange = (e) => {
    const value = e.target.value;
    setTipoTripa(value);
    // valida se a qualidade/calibre atual ainda são compatíveis
    if (tipoQualidade && !produtos.some(p => p.tipo === value && p.qualidade === tipoQualidade)) {
      setTipoQualidade('');
    }
    if (calibre && !produtos.some(p => p.tipo === value && p.calibre === calibre)) {
      setCalibre('');
    }
  };

  //Memorização das datas de validade das tabelas
  const datasValidade = useMemo(() => {
    const datas = produtos.map(p => p.tdtaDtaInicio).filter(Boolean);
    return datas.length > 0 ? new Date(Math.max(...datas.map(d => new Date(d)))) : null;
  }, [produtos]);

  const handleTipoQualidadeChange = (e) => {
    const value = e.target.value;
    setTipoQualidade(value);
    if (tipoTripa && !produtos.some(p => p.qualidade === value && p.tipo === tipoTripa)) {
      setTipoTripa('');
    }
    if (calibre && !produtos.some(p => p.calibre === value && p.calibre === calibre)) {
      setCalibre('');
    }
  };

  const handleCalibreChange = (e) => {
    const value = e.target.value;
    setCalibre(value);
    if (tipoTripa && !produtos.some(p => p.qualidade === value && p.tipo === tipoTripa)) {
      setTipoTripa('');
    }
    if (tipoQualidade && !produtos.some(p => p.calibre === value && p.qualidade === tipoQualidade)) {
      setTipoQualidade('');
    }
  };

  const handleLimparFiltros = () => {
    setSearchTerm('');
    setSelectedProduto(null);
    setShowSuggestions(false);
    setTipoTripa('');
    setTipoQualidade('');
    setCalibre('');
  };

  return (
  <div className="produto-page">
    {loadingProdutos ? (
       <div className="loading-container" tabIndex={-1}>
        <img src={logo} alt="Logo" className="loading-logo" />
        <p>Carregando Tabela de Preços...</p>
      </div>
    ) : (
    <>
      <div className="header">
        <img src={logo} alt="Logo" className="header-logo" />
        <h1>Produtos</h1>
      </div>
      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      {/* 🔎 Filtro */}
      <div className="produto-box">
        <div>
          <input
            type="text"
            placeholder="Pesquisar Produtos..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setShowSuggestions(true);
              setSelectedProduto(null);
            }}
            onFocus={() => setShowSuggestions(true)}
          />
        </div>

        <div className="filtros">
          <div className="filtros-label">
            <select className="tipoTripa" value={tipoTripa} onChange={handleTipoTripaChange}>
              <option value="">Todos os tipos</option>
              {tiposTripa.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>

            <select className="tipoTripa" value={tipoQualidade} onChange={handleTipoQualidadeChange}>
              <option value="">Tipo de Qualidade</option>
              {tiposQualidade.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>

            <select className="tipoTripa" value={calibre} onChange={handleCalibreChange}>
              <option value="">Tipo de Calibre</option>
              {calibres.map((item) => (
                <option key={item} value={item}>{item}</option>
              ))}
            </select>
          </div>

          <div className='filtros-label'>
            <select className="tipoTripa" value={datasValidade ? datasValidade.toISOString().split('T')[0] : ''} disabled>
              <option value="">{datasValidade ? `Data de Validade: ${datasValidade.toLocaleDateString()}` : 'Sem Data de Validade'}</option>
            </select>

            <button className="btnLimparFiltros" onClick={handleLimparFiltros}>Limpar Filtros</button>
          </div>
        </div>

        {selectedProduto && (
          <div className="produto-selecionado">
            <h3>Produto Selecionado:</h3>
            <p><strong>{selectedProduto.descricao}</strong></p>
          </div>
        )}

        {searchTerm && (
          <button
            className="btn-limpar"
            onClick={() => {
              setSearchTerm('');
              setSelectedProduto(null);
              setShowSuggestions(false);
            }}
          >
            Limpar
          </button>
        )}

        {showSuggestions && searchTerm && (
          <ul className="produto-list">
            {filteredProdutos.length > 0 ? (
              filteredProdutos.map((p, index) => (
                <li key={`${p.tabId}-${index}`} onClick={() => handleSelectProduto(p)}>
                  {p.descricao}
                </li>
              ))
            ) : (
              <li>❌ Nenhum Produto encontrado</li>
            )}
          </ul>
        )}
      </div>

      {/* 🧾 Lista de produto em Blocos */}
      <div className="produto-container-Cadastro">
        {filteredProdutos
          .filter(p => !tipoTripa || p.tipo === tipoTripa)
          .filter(p => !tipoQualidade || p.qualidade === tipoQualidade)
          .filter(p => !calibre || p.calibre === calibre)
          .map((produto) => {

          return (
            <div key={produto.tabId} className="produto-card-cadastro">
              <div className={`cabProduto`}>
                <table className='tabelaProduto'>
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Tabela {produto.percomissao2.toLocaleString("pt-BR")}%</th>
                      <th>Tabela {produto.percomissao3.toLocaleString("pt-BR")}%</th>
                      <th>Tabela {produto.percomissao4.toLocaleString("pt-BR")}%</th>
                      <th>Tabela {produto.percomissao5.toLocaleString("pt-BR")}%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{produto.descricao}</td>
                      <td>{produto.comissao2.toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}</td>
                      <td>{produto.comissao3.toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}</td>
                      <td>{produto.comissao4.toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}</td>
                      <td>{produto.comissao5.toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}</td>
                    </tr>
                  </tbody>
                </table>
                
              </div>
            </div>
          );
        })}
      </div>
    </>
    )}
  </div>    
  );
};

export default Cliente;